import React from "react";
import PropTypes from "prop-types";
import className from "classnames";

import "./banner.less";

export default function Banner({ alert, children }) {
  return (
    <div className={className("Banner", alert && "Banner--alert")}>
      {children}
    </div>
  );
}

Banner.propTypes = {
  alert: PropTypes.bool,
  children: PropTypes.node
};
